export default __webpack_public_path__ + "static/media/hyo_sung_lee.e3034b26.png";